import { __rest } from './../../../external/tslib/tslib.es6.js';
import React from 'react';
import { useAccordionItem } from './AccordionItem.js';
import { useAccordionRoot } from './AccordionRootProvider.js';

function AccordionTrigger(_a) {
    var { children, onClick } = _a, props = __rest(_a, ["children", "onClick"]);
    const { setOpenedAccordion } = useAccordionRoot();
    const { value } = useAccordionItem();
    function handleOnClick(event) {
        setOpenedAccordion(value);
        if (onClick) {
            onClick(event);
        }
    }
    return (React.createElement("button", Object.assign({ onClick: handleOnClick, tabIndex: 1, type: "button" }, props), children));
}

export { AccordionTrigger };
